import React, { Component } from "react";
import {
  DarkToken,
  LightToken,
  HighlightToken
} from "../CatalogSpecimenPreview";

import "./ColorSpecimenExample.css";

class ColorSpecimenExample extends Component {
  render() {
    return (
      <div className="color-specimen-example">
        <div className="color color-100">
          <div className="labels">
            <div className="name">RED 100</div>
            <div className="value">#FFC2C2</div>
          </div>
        </div>
        <div className="color color-200">
          <div className="labels">
            <div className="name">RED 200</div>
            <div className="value">#FF9999</div>
          </div>
        </div>
        <div className="color color-300">
          <div className="labels">
            <div className="name">RED 300</div>
            <div className="value">#FF7777</div>
          </div>
        </div>
        <div className="color color-400">
          <div className="labels">
            <div className="name">RED 400</div>
            <div className="value">#FF5555</div>
          </div>
        </div>
      </div>
    );
  }
}

export default ColorSpecimenExample;

export const colorSpecimenExampleSource = [
  [<DarkToken>{"```color-palette|horizontal"}</DarkToken>],
  [<LightToken>{"colors:"}</LightToken>],
  [
    <LightToken>{"  - {name: "}</LightToken>,
    <HighlightToken>{"'RED 100'"}</HighlightToken>,
    <LightToken>{", value: "}</LightToken>,
    <HighlightToken>{"'#FFC2C2'"}</HighlightToken>
  ],
  [
    <LightToken>{"  - {name: "}</LightToken>,
    <HighlightToken>{"'RED 200'"}</HighlightToken>,
    <LightToken>{", value: "}</LightToken>,
    <HighlightToken>{"'#FF9999'"}</HighlightToken>
  ],
  [
    <LightToken>{"  - {name: "}</LightToken>,
    <HighlightToken>{"'RED 300'"}</HighlightToken>,
    <LightToken>{", value: "}</LightToken>,
    <HighlightToken>{"'#FF7777'"}</HighlightToken>
  ],
  [
    <LightToken>{"  - {name: "}</LightToken>,
    <HighlightToken>{"'RED 400'"}</HighlightToken>,
    <LightToken>{", value: "}</LightToken>,
    <HighlightToken>{"'#FF5555'"}</HighlightToken>
  ],
  [<DarkToken>{"```"}</DarkToken>]
];



// WEBPACK FOOTER //
// ./src/components/specimen-examples/ColorSpecimenExample.js